<template>
  <div>
    <nav style="position: sticky; top:0; z-index:2;">
      <Navigation chosenpage="Document" @setDrawer="drawerSet" />
    </nav>

    <v-card flat style="display:flex; flex-direction:row; padding:0;">
      <v-col cols="6" style="padding:20px 0 10px 25px">
        <v-autocomplete
          :items="[
            { id: 1, name: 'Sparepart' },
            { id: 2, name: 'Bahan baku' },
            { id: 3, name: 'Assets' }
          ]"
          cache-items
          class="mx-4"
          flat
          hide-no-data
          hide-details
          label="Pilih Kategori"
          solo-inverted
          item-text="name"
          item-value="id"
          return-id
          dense
        ></v-autocomplete>
      </v-col>
      <v-col cols="6" style="padding:20px 55px 10px 30px">
        <v-text-field
          dense
          flat
          solo-inverted
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-card>

    <v-responsive class="overflow-y-auto" max-height="80vh">
      <v-responsive class="text-center pa-2">
        <v-row style="width:99%; margin:auto;">
          <v-col
            v-for="(item, idxKey) in apps"
            :key="idxKey"
            cols="12"
            style="padding: 10px 0;"
          >
            <v-lazy
              :options="{
                threshold: 0.5
              }"
              transition="fade-transition"
              style="padding:0 20px;"
              class="justify-content-center align-items-center"
            >
              <v-card
                class="mx-auto"
                width="97%"
                outlined
                elevation="6"
                style="padding: 10px;"
              >
                <v-col
                  cols="12"
                  style="padding:0; display:flex; flex-direction:row; justify-content:center; align-items:center; "
                >
                  <v-col cols="6" style="padding:0;">
                    <v-card-title
                      style="height:50px; font-size:16px; padding:0; width:100%;"
                    >
                      {{ item }}
                    </v-card-title>
                  </v-col>
                  <v-col cols="6" style="padding:0;" class="text-right">
                    <v-btn
                      elevation="1"
                      outlined
                      width="120"
                      text
                      style="font-size:12px;"
                    >
                      <v-icon dark>
                        mdi-download
                      </v-icon>
                      Download
                    </v-btn>
                  </v-col>
                </v-col>
              </v-card>
            </v-lazy>
          </v-col>
        </v-row>
      </v-responsive>
    </v-responsive>

    <v-navigation-drawer v-model="drawer" fixed height="100vh" temporary>
      <Drawer />
    </v-navigation-drawer>

    <div>
      <ProductCompare v-if="getProductCompareStat" />
    </div>
    <v-footer
      dark
      padless
      style="position: relative; bottom:0; margin-top:20px;"
    >
      <Footer :footer="true" />
    </v-footer>
  </div>
</template>
<script>
import Navigation from '../../components/navigation/Navigation'
import Drawer from '../../components/navigation/Drawer'
import Footer from '../../components/navigation/footer'
import ProductCompare from '../../components/eCatalogue/catalogue_list/ProductCompare'
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  data: () => ({
    isActive: false,
    apps: ['Epson iProjection 2.2', 'Memo HRD'],
    drawer: false,

    more: ['News', 'Maps', 'Books', 'Flights', 'Apps'],
    productSelection: []
  }),
  components: { Navigation, Drawer, ProductCompare, Footer },
  computed: {
    ...mapGetters(['getProductCompareStat'])
  },
  methods: {
    ...mapActions(['logout', 'compareProduct']),
    ...mapMutations(['productCompare']),
    drawerSet(val) {
      this.drawer = val
    },
    home() {
      this.$router.push('/')
    },
    selectItems(value) {
      if (this.productSelection.includes(value)) {
        const index = this.productSelection.indexOf(value)
        this.productSelection.splice(index, 1)
      } else {
        this.productSelection.push(value)
      }
    },
    removeAllCompareItems() {
      this.productSelection = []
    },
    remove(index) {
      this.productSelection.splice(index, 1)
    },
    compareItems() {
      this.productCompare(true)
      this.compareProduct(this.productSelection)
    },
    truncateString(item) {
      return item.toLowerCase()
    },
    viewDetail(data) {
      this.$router.push('/e-catalogue/catalogue-detail')
    }
  }
}
</script>

<style lang="scss">
#dashboard {
  position: relative;
  width: 100%;
  min-height: 90vh;
  padding: 30px 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
